import _ from 'lodash'
import moment from 'moment'
import { dateKeyFormat } from '../../configuration/calendar'

function getFilteredScheduleForCategories(currentEventSchedule, activeCategories) {
  if (_.isEmpty(activeCategories)) return currentEventSchedule

  return _.filter(
    currentEventSchedule,
    (schedule) => _.intersection(activeCategories, schedule?.categories).length > 0
  )
}

function getFilteredScheduleForLocations(currentEventSchedule, activeLocations) {
  if (_.isEmpty(activeLocations)) return currentEventSchedule

  return _.filter(currentEventSchedule, (schedule) =>
    _.includes(activeLocations, schedule?.location)
  )
}

export default function getFilteredSchedule(
  eventSchedule,
  activeCategories,
  activeLocations,
  startDate,
  endDate
) {
  let day = startDate
  let filteredEventSchedule = {}

  while (day <= endDate) {
    const dateKey = moment(day).format(dateKeyFormat)
    const currentEventSchedule = eventSchedule[dateKey]

    const categoriesFilteredSchedule = getFilteredScheduleForCategories(
      currentEventSchedule,
      activeCategories
    )

    const locationCategoriesfilteredSchedule = getFilteredScheduleForLocations(
      categoriesFilteredSchedule,
      activeLocations
    )

    filteredEventSchedule = {
      ...filteredEventSchedule,
      [dateKey]: locationCategoriesfilteredSchedule,
    }

    day.add(1, 'day')
  }
  return filteredEventSchedule
}
